import { defineMessages } from 'react-intl';

export default defineMessages({
    enterYourDetailsHeader: {
        id: 'enrollment.components.enrollment.Add Policy',
        defaultMessage: 'Add Policy'
    },
    enroll: {
        id: 'enrollment.components.enrollment.Add policy',
        defaultMessage: 'Add policy'
    },
    enrollmentAddressLine1: {
        id: 'enrollment.components.enrollment.Address Line 1:',
        defaultMessage: 'Address Line 1:'
    },
    enrollmentPolicyNumber: {
        id: 'enrollment.components.enrollment.Policy Number:',
        defaultMessage: 'Policy Number:'
    },
    returnToHomePage: {
        id: 'enrollment.components.enrollment.Return to Home Page',
        defaultMessage: 'Return to Home Page'
    },
    enrollmentFailed: {
        id: 'enrollment.components.enrollment.Sorry we cannot process your enrollment request at this time',
        defaultMessage: 'Sorry we cannot process your enrollment request at this time'
    },
    enrollmentInvalid: {
        id: 'enrollment.components.enrollment.Please ensure you have entered the Policy Number correctly ',
        defaultMessage: 'Please ensure you have entered the Policy Number correctly'
    },
    enrollmentSuccess: {
        id: 'enrollment.components.enrollment.Policy added successfully',
        defaultMessage: 'Policy added successfully'
    },
    fieldEmpty: {
        id: 'enrollment.components.enrollment.Enter the policy number to associate with this account',
        defaultMessage: 'Enter the policy number to associate with this account'
    },
    accessToYourPolicies: {
        id: 'enrollment.components.enrollment.You now have access to your policies:',
        defaultMessage: 'You now have access to your policies:'
    },
    accessToYourPolicy: {
        id: 'enrollment.components.enrollment.You now have access to your policy:',
        defaultMessage: 'You now have access to your policy: {policyNumber}'
    },
    enrollmentPendingNotificationMessage : {
        id: 'enrollment.components.enrollment.Your request to access policy: {policyNumber} has been registered. We will get in touch with you to add the policy to your online account.',
        defaultMessage: 'Your request to access policy: {policyNumber} has been registered. We will get in touch with you to add the policy to your online account.'
    },
    confirmPolicyDetailsMessage : {
        id: 'enrollment.components.enrollment.Please ensure you have entered the Policy Number correctly as your name does not exactly match an insured for this policy.',
        defaultMessage: 'Please ensure you have entered the Policy Number correctly as your name does not exactly match an insured for this policy.'
    },
    sendEnrollmentRequest1 : {
        id: 'enrollment.components.enrollment.If you believe you entered the correct policy number please click Ok to have this reviewed',
        defaultMessage: 'If you believe you entered the correct policy number please click Ok to have this reviewed.'
    },
    edit : {
        id: 'enrollment.components.enrollment.edit',
        defaultMessage: 'Edit Policy Number'
    },
    ok : {
        id: 'enrollment.components.enrollment.ok',
        defaultMessage: 'Ok'
    },
    errorAddingPolicy : {
        id: 'enrollment.components.enrollment.errorAddingPolicy',
        defaultMessage: 'Error adding policy'
    },
    verificationInfoText:{
        id: 'enrollment.components.additionalenrollment.verificationInfoText',
        defaultMessage: 'If your policy number is not listed above, please provide the policy number you want to add.'
    }
});
